import utils from '../utils.js';
import defaults from '../defaults/index.js';
import AxiosHeaders from './AxiosHeaders.js';

function transformData(fns,response){const config=this||defaults;const context=response||config;const headers=AxiosHeaders.from(context.headers);let data=context.data;utils.forEach(fns,function transform(fn){data=fn.call(config,data,headers.normalize(),response?response.status:undefined);});headers.normalize();return data}

export { transformData as default };
//# sourceMappingURL=transformData.js.map
